{
  "audit": {
    "title": "Журнал аудита"
  }
}